import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextInput from '../../components/TextInput';
import TextAreaInput from '../../components/TextAreaInput';
import CheckboxInput from '../../components/CheckboxInput';
import Button from '../../components/Button';
import SkeletonLoader from '../../components/SkeletonLoader';
import serviceApi from '../../api/faqApi';
import { useToast } from '../../contexts/ToastContext';

const AddFAQ = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [formData, setFormData] = useState({
    question: '',
    answer: '',
    is_active: 1, // Use is_active to match backend
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    });
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setValidationErrors({});

    try {
      await serviceApi.createFaq(formData); // Use serviceApi to create FAQ
      addToast('FAQ created successfully!', 'success');
      navigate('/faqs');
    } catch (err) {
      console.error('Failed to add FAQ:', err);
      if (err.response && err.response.status === 422) {
        setValidationErrors(err.response.data.errors || {});
        addToast(err.response.data.message || 'Validation failed. Please check your input.', 'error');
      } else {
        addToast(err.response?.data?.message || 'Failed to add FAQ. Please try again.', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-800 rounded-lg shadow-md text-text-white">
      <h1 className="text-3xl font-bold mb-6">Add New FAQ</h1>
      {loading ? (
        <SkeletonLoader type="form" />
      ) : (
        <form onSubmit={handleSubmit}>
          <TextInput
            label="Question"
            name="question"
            id="question"
            value={formData.question}
            onChange={handleChange}
            required={true}
            placeholder="Question"
            error={validationErrors?.question?.[0]}
          />
          <TextAreaInput
            label="Answer"
            name="answer"
            id="answer"
            value={formData.answer}
            onChange={handleChange}
            required={true}
            rows={4}
            placeholder="Answer"
            error={validationErrors?.answer?.[0]}
          />
          <CheckboxInput
            label="Active"
            name="is_active" // Use is_active to match backend
            id="is_active"
            checked={formData.is_active}
            onChange={handleChange}
          />
          <div className="flex items-center justify-between mt-6">
            <Button
              type="submit"
              className="bg-accent-red hover:bg-red-700 text-white"
              loading={loading}
            >
              Add FAQ
            </Button>
            <Button
              type="button"
              onClick={() => navigate('/faqs')}
              className="bg-gray-500 hover:bg-gray-600 text-white"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddFAQ;